import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import * as styles from './styles/styles.module.scss';

// note: Im not a huge fan of this inline svg. Definitely want to tackle the overarching issues with theming the material ui components
const checkImage =
  "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
  " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
  "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")";

// todo: investigate if it's possible to move these style definitions into the css module
const checkBoxStyles = makeStyles({
  root: {
    '&:hover': {
      backgroundColor: '#69a04110 !important' // Note: didnt see any way to avoid !important to override built in styles
    }
  },
  icon: {
    width: 16,
    height: 16,
    border: '1px solid #ccc',
    borderRadius: 4
  },
  checkedIcon: {
    backgroundColor: '#428a13',
    borderColor: '#428a13',
    '&:before': {
      display: 'block',
      width: 14,
      height: 14,
      backgroundImage: checkImage,
      content: '""'
    },
    'input:hover ~ &': {
      backgroundColor: '#69a041'
    }
  }
});

const labelStyles = makeStyles({
  label: {
    fontFamily: 'Proxima Nova, Arial, sans-serif',
    fontSize: 14
  }
});

const rippleStyles = makeStyles({
  child: {
    backgroundColor: '#69a041'
  },
  rippleVisible: {
    opacity: 0.3
  }
});

export default function CheckboxFilter({ config, handler }) {
  const classes = checkBoxStyles();
  const labelClasses = labelStyles();
  const rippleClasses = rippleStyles();
  const renderOptions = options => {
    const result = [];
    Object.keys(options).map(key => {
      return result.push(
        <li key={key} className={styles.item}>
          <FormControlLabel
            value={options[key].value}
            classes={labelClasses}
            onChange={handler(key)}
            control={
              <Checkbox
                className={classes.root}
                checked={options[key].selected}
                checkedIcon={<span className={`${classes.checkedIcon} ${classes.root} ${classes.icon}`} />}
                TouchRippleProps={{ classes: rippleClasses }}
                icon={<span className={classes.icon} />}
                value={options[key].value}
              />
            }
            label={options[key].name}
            labelPlacement="end"
          />
        </li>
      );
    });
    return result;
  };

  return (
    <div>
      <ul className={styles.list}>{renderOptions(config)}</ul>
    </div>
  );
}
